import { Survey } from '../types/Survey';

import { baseApi } from './baseApi';

export const surveyApi = baseApi
  .enhanceEndpoints({ addTagTypes: ['Survey'] })
  .injectEndpoints({
    endpoints: (builder) => ({
      getAllSurveys: builder.query<Survey[], void>({
        query: () => 'api/v6/careplan/surveys',
        // Note: this is just for invalidation and
        // it does not store the same object cache as the individual survey endpoint
        // https://redux-toolkit.js.org/rtk-query/usage/cache-behavior#no-normalized-or-de-duplicated-cache
        providesTags: (result, _error, _arg) => (
          result ? [...result.map(({ id }) => ({ type: 'Survey' as const, id }))] : ['Survey']
        ),
      }),
      getSurvey: builder.query<Survey, number>({
        query: (id: number) => `api/v6/careplan/survey?procedure_id=${id}`,
        providesTags: (_result, _error, arg) => ([{ type: 'Survey', id: arg }]),
      }),
    }),
    overrideExisting: false,
  });

// Export hooks for usage in function components, which are
// auto-generated based on the defined endpoints
export const {
  useGetAllSurveysQuery,
  useGetSurveyQuery,
  useLazyGetSurveyQuery,
  useLazyGetAllSurveysQuery,
} = surveyApi;
